<template>
  <div class="preview-file-box">
    <div class="fileBox"></div>
    <div class="page">{{ currentPage }}/{{ pdfObject.totalNumber }}</div>
    <div class="goDown goUp" @click="goUp">
      <i class="el-icon-arrow-up"></i>
    </div>
    <div class="goDown" @click="goDown">
      <i class="el-icon-arrow-down"></i>
    </div>
    <!-- <div class="beforeOfFile" @click="beforeOfFile">
      <img src="../../../../assets/images/index/beforeFile.png" alt="" />
    </div>
    <div class="afterOfFile" @click="afterOfFile">
      <img src="../../../../assets/images/index/afterFile.png" alt="" />
    </div> -->
  </div>
</template>
  
  <script>
export default {
  name: "",
  props: {
    fileArr: {
      type: Array,
      default: () => [],
    },
    fileIndexProp: {
      type: Number,
      default: 0,
    },
  },

  components: {},

  data() {
    return {
      pdfObject: {
        zoom: false,
        scale: 1.2,
        newScale: 1.4,
        currentIndex: 1,
        totalNumber: 0,
        path: "",
      },
      thePDF: null, // 当前渲染pdf object
      scrollTop: 0, // 滚动距离
      fileIndex: 0, // 当前文件索引

      previewImageVisible: false,
    };
  },

  created() {
    this.fileIndex = this.fileIndexProp || 0;
    this.pdfObject.path = this.fileArr[this.fileIndex].filePath;
  },
  mounted() {
    this.$nextTick(() => {
      this.pdfRender();
      const dom = document.querySelector(".preview-file-box");
      dom.addEventListener(
        "scroll",
        (e) => {
          this.scrollTop = dom.scrollTop;
        },
        true
      );
    });
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },
    pdfRender() {
      var _this = this;
      //   var canvas = this.$refs.theCanvas;
      // var newCanvas = this.$refs.newCanvas;
      var url = this.pdfObject.path;
      // var url = '../../assets/images/1.pdf';
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.thePDF = pdf;
        _this.pdfObject.totalNumber = pdf.numPages;
        pdf.getPage(_this.pdfObject.currentIndex).then(_this.handlePages);
      });
    },
    handlePages(page) {
      var _this = this;

      /* Canvas Start */
      var canvas = document.createElement("canvas");
      canvas.style.display = "block";
      canvas.style.marginBottom = "10px";
      canvas.style.background = "#ffffff";
      canvas.style.boxShadow = "0 0 16px #999";
      canvas.className = "canvas";
      var scale = _this.pdfObject.scale;
      var viewport = page.getViewport(scale);
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      var renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      page.render(renderContext);
      document.querySelector(".fileBox").appendChild(canvas);
      this.pdfObject.currentIndex++;
      if (
        this.pdfObject.path !== null &&
        this.pdfObject.currentIndex <= this.pdfObject.totalNumber
      ) {
        _this.thePDF
          .getPage(_this.pdfObject.currentIndex)
          .then(_this.handlePages);
      }
    },
    goDown() {
      const domList = document.getElementsByClassName("canvas");

      domList[domList.length - 1].scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
    },
    goUp() {
      // 获取第一个canvas
      document
        .querySelector(".canvas")
        .scrollIntoView({ behavior: "smooth", inline: "nearest" });
    },
    beforeOfFile() {
      if (this.fileIndex <= 0) {
        return this.$message.warning("当前已经是第一份文件了");
      }
      document.querySelector(".fileBox").innerHTML = "";
      this.pdfObject.currentIndex = 1;
      this.fileIndex--;
      this.pdfObject.path = this.fileArr[this.fileIndex].filePath;
      this.pdfRender();
    },
    afterOfFile() {
      if (this.fileIndex >= this.fileArr.length - 1) {
        return this.$message.warning("当前已经是最后一份文件了");
      }
      document.querySelector(".fileBox").innerHTML = "";
      this.pdfObject.currentIndex = 1;
      this.fileIndex++;
      this.pdfObject.path = this.fileArr[this.fileIndex].filePath;
      this.pdfRender();
    },
  },
  computed: {
    currentPage() {
      return Math.floor((this.scrollTop + 500) / 1000) + 1;
    },
  },
};
</script>
  
  <style scoped lang="scss">
.preview-file-box {
  height: calc(100vh - 206px);
  overflow: auto;
  background-color: #eaedf1;
}
.page {
  position: absolute;
  bottom: 80px;
  right: 40px;
  width: 65px;
  height: 28px;
  background: #bdbdbd;
  border-radius: 4px;
  line-height: 28px;
  text-align: center;
  color: #ffffff;
  z-index: 1;
}
.fileBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 50px 0 40px 0;
  canvas {
    margin: 0 auto 5px;
  }
}
.goDown {
  position: absolute;
  bottom: 120px;
  right: 40px;
  background-color: #bdbdbd;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 20px;
  -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
  i {
    color: #ffffff;
  }
  // &:hover {
  //   background-color: #f2f6fc;
  // }
}
.goUp {
  bottom: 168px;
}
.beforeOfFile {
  position: absolute;
  left: -104px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.afterOfFile {
  position: absolute;
  right: -104px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
::v-deep {
  .el-dialog__header {
    display: block !important;
  }
  .el-dialog__body {
    height: 670px;
    overflow-y: auto;
    background-color: #f5f5f5;
  }
  .el-dialog {
    transform: scale(1);
    padding-bottom: 30px;
    background-color: #f5f5f5;
    position: relative;
    margin-top: 12vh;
  }
}
</style>
  